import React from "react";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { morning_img_03, userdoctor } from "../../imagepath";
import { calendar } from "../../imagepath";
import CountUp from "react-countup";

const Card_PatientDashboard = () => {
  return (
    <>
      <Header />
      <Sidebar id="menu-item" />

      <div className="page-wrapper">
        <div className="content">
          {/*Page Header line*/}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="#">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right">
                      <FeatherIcon icon="chevron-right" />
                    </i>
                  </li>
                  <li className="breadcrumb-item active">
                    Welcome to Your Dashboard
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/*Page Header*/}
          <div className="good-morning-blk">
            <div className="row">
              <div className="col-md-6">
                <div className="morning-user">
                  <h2>
                    Good Morning, <span>Smith Bruklin</span>
                  </h2>
                  {/* <p>Have a nice day</p> */}
                </div>
              </div>
              <div className="col-md-6 position-blk">
                <div className="morning-img">
                  <img src={morning_img_03} alt="#" />
                </div>
              </div>
            </div>
          </div>
          {/*Page Card Content*/}
          <div className="row">
            <div className="col-12 col-md-12 col-lg-12 col-xl-4">
              <div className="card">
                <div className="card-body">
                  <div className="dash-boxs comman-flex-center">
                    <img src={calendar} alt="#" />
                  </div>
                  <div className="card-title col">
                    <Link to="/upcomming">
                      <h4>Upcoming Appointments</h4>
                    </Link>
                  </div>
                  <div className="dash-content dash-count flex-grow-1">
                    <h2>
                      {" "}
                      <CountUp delay={0.4} end={4} duration={3} />
                    </h2>
                  </div>
                  <div className="card-footer">
                    <h4>No. of appointment</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12 col-xl-4 d-flex">
              <div className="card">
                <div className="card-body">
                  <div className="dash-boxs comman-flex-center">
                    <img
                      style={{ width: "24px", height: "24px" }}
                      src={userdoctor}
                      alt="#"
                    />
                  </div>
                  <div className="card-title col">
                    <Link to="/careteampatient">
                      <h4>No. of consultations</h4>
                    </Link>
                  </div>
                  <div className="dash-content dash-count flex-grow-1">
                    <h2>
                      {" "}
                      <CountUp delay={0.4} end={3} duration={3} />
                    </h2>
                  </div>

                  <div className="card-footer">
                    <h4>Care team members</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-12 col-lg-12 col-xl-4 d-flex">
              <div className="card">
                <div className="card-body">
                  <div className="dash-boxs comman-flex-center">
                    <img src={calendar} alt="#" />
                  </div>
                  <div className="card-title col">
                    <Link to="/appointment">
                      <h4>Appointments</h4>
                    </Link>
                  </div>
                  <div className="dash-content dash-count flex-grow-1">
                    <h2>
                      {" "}
                      <CountUp delay={0.4} end={2} duration={3} />
                    </h2>
                  </div>
                  <div className="card-footer">
                    <h4>Appointments</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card_PatientDashboard;
